import { Button, ModalOverlay, Text } from "@components/atoms";

interface SuccessModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  message: string;
  buttonText?: string;
  /** Optional second button (transparent style) */
  secondaryButtonText?: string;
  onSecondaryClick?: () => void;
}

/**
 * Success modal molecule.
 * Reusable success confirmation with green checkmark.
 * Supports optional secondary (outline) button.
 */
export function SuccessModal({
  isOpen,
  onClose,
  title,
  message,
  buttonText = "Aceptar",
  secondaryButtonText,
  onSecondaryClick,
}: SuccessModalProps) {
  return (
    <ModalOverlay isOpen={isOpen} onClose={onClose}>
      <div
        className="flex flex-col items-center justify-center gap-4 rounded-2xl bg-white p-6 sm:p-8 w-full max-w-[550px]"
        style={{ minHeight: 320 }}
      >
        <Text
          variant="h2"
          as="h2"
          className="font-semibold text-black text-center"
        >
          {title}
        </Text>
        <img
          src="/svg/success_icon.svg"
          alt="Success"
          width={140}
          height={140}
        />
        <Text variant="body" as="p" className="text-black text-center">
          {message}
        </Text>

        {/* Button row */}
        <div className="mt-2 flex flex-col sm:flex-row items-center gap-4">
          <Button
            className="w-full sm:w-[220px] h-[50px] border border-primary-110 bg-secondary-120 hover:opacity-90"
            onClick={onClose}
          >
            {buttonText}
          </Button>

          {secondaryButtonText && onSecondaryClick && (
            <Button
              className="w-full sm:w-[220px] h-[50px] border border-primary-110 bg-transparent hover:bg-neutral-10"
              onClick={onSecondaryClick}
            >
              {secondaryButtonText}
            </Button>
          )}
        </div>
      </div>
    </ModalOverlay>
  );
}
